import { useQuery } from '@tanstack/react-query'
import { notificationsQueryKeys } from '../constants'
import api from '../../config/axios-config'
/**
 * Checks if the current user has unread notifications.
 * @param {Object} options - Additional options for `useQuery`.
 * @returns {Object} - Query result with payload `{ check: boolean }`.
 * Endpoint:
 * Service: GET /notifications-api/v1/notifications/unread
 * Frontend proxy: GET /api/notifications/unread
 * Recommended strategy:
 * Call on app boot and when user regains focus to keep the notification badge in sync.
 * Re-fetch after write operations (`read` / `read all`) to avoid temporary badge drift.
 */

export const useNotificationsUnreadQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api(`/api/notifications/unread`, config)

    return data
  }

  return useQuery({
    queryKey: [notificationsQueryKeys.NOTIFICATIONS_UNREAD],
    queryFn: handleQuery,
    ...options
  })
}
